// extracted by mini-css-extract-plugin
module.exports = {"styles":"kIxYcGnczr_o6H_l47FLp"};